import uiClickUrl from './sounds/sfx/ui_click.mp3';
import uiClickBUrl from './sounds/sfx/ui_click_b.mp3';
import uiInfoUrl from './sounds/sfx/ui_info.mp3';
import uiInfoBUrl from './sounds/sfx/ui_info_b.mp3';
import deliveryTakeUrl from './sounds/sfx/delivery_take.mp3';
import deliveryTakeBUrl from './sounds/sfx/delivery_take_b.mp3';
import deliverySuccessUrl from './sounds/sfx/delivery_success.mp3';
import deliveryFailUrl from './sounds/sfx/delivery_fail.mp3';
import runnerHitUrl from './sounds/sfx/runner_hit.mp3';
import runnerHitBUrl from './sounds/sfx/runner_hit_b.mp3';
import runnerSparkUrl from './sounds/sfx/runner_spark.mp3';
import runnerSparkBUrl from './sounds/sfx/runner_spark_b.mp3';
import runnerBoosterUrl from './sounds/sfx/runner_booster.mp3';
import runnerBoosterBUrl from './sounds/sfx/runner_booster_b.mp3';
import runnerFinishUrl from './sounds/sfx/runner_finish.mp3';
import loadingSfxUrl from './sounds/sfx/loading_sfx.mp3';
import techLikeMusicUrl from './sounds/music/tech-like-music.mp3';
import mapMusicUrl from './sounds/music/map.mp3';
import mapMusic2Url from './sounds/music/map-2.mp3';
import levelMusicUrl from './sounds/music/level.mp3';

export const SOUND_IDS = [
  'ui.click',
  'ui.click_b',
  'ui.info',
  'ui.info_b',
  'delivery.take',
  'delivery.take_b',
  'delivery.success',
  'delivery.fail',
  'runner.hit',
  'runner.hit_b',
  'runner.spark',
  'runner.spark_b',
  'runner.booster',
  'runner.booster_b',
  'runner.finish',
  'loading.sfx',
  'music.tech_like',
  'music.map',
  'music.map_2',
  'music.level',
] as const;

export type SoundId = (typeof SOUND_IDS)[number];

/** Sounds that should not stack (single Howl instance, pool size 1). */
export const SINGLE_INSTANCE_SOUND_IDS: ReadonlySet<SoundId> = new Set([
  'music.tech_like',
  'music.map',
  'music.map_2',
  'music.level',
]);

/**
 * Background tracks that loop as a single Howl.
 * Level music uses a playlist (not Howl-looped) — see preloadSounds.
 */
export const LOOPING_SOUND_IDS: ReadonlySet<SoundId> = new Set([
  'music.map',
]);

/** Level gameplay BGM playlist — played in order, then repeats. */
export const LEVEL_MUSIC_PLAYLIST: readonly SoundId[] = [
  'music.level',
  'music.map_2',
];

export const soundUrls: Readonly<Record<SoundId, string>> = {
  'ui.click': uiClickUrl,
  'ui.click_b': uiClickBUrl,
  'ui.info': uiInfoUrl,
  'ui.info_b': uiInfoBUrl,
  'delivery.take': deliveryTakeUrl,
  'delivery.take_b': deliveryTakeBUrl,
  'delivery.success': deliverySuccessUrl,
  'delivery.fail': deliveryFailUrl,
  'runner.hit': runnerHitUrl,
  'runner.hit_b': runnerHitBUrl,
  'runner.spark': runnerSparkUrl,
  'runner.spark_b': runnerSparkBUrl,
  'runner.booster': runnerBoosterUrl,
  'runner.booster_b': runnerBoosterBUrl,
  'runner.finish': runnerFinishUrl,
  'loading.sfx': loadingSfxUrl,
  'music.tech_like': techLikeMusicUrl,
  'music.map': mapMusicUrl,
  'music.map_2': mapMusic2Url,
  'music.level': levelMusicUrl,
};

export function getSoundUrl(id: SoundId): string {
  return soundUrls[id];
}
